export const lowercaseFirstLetter = (t: string = '') => {
  if (t.length >= 2) {
    return t[0].toLowerCase() + t.substring(1);
  }
  return '';
};
